var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-size.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"primarySlice")),"sliceItems")),0)),"includedSkus")),0)),"sizeId");
frame.set("productSizeId", t_1, true);
if(frame.topLevel) {
context.setVariable("productSizeId", t_1);
}
if(frame.topLevel) {
context.addExport("productSizeId", t_1);
}
output += "\n";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"primarySlice")),"sliceItems")),0)),"includedSkus")),0)),"sizeTypeCode");
frame.set("productSizeTypeCode", t_2, true);
if(frame.topLevel) {
context.setVariable("productSizeTypeCode", t_2);
}
if(frame.topLevel) {
context.addExport("productSizeTypeCode", t_2);
}
output += "\n";
var t_3;
t_3 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"secondarySlice")),"displayLabel");
frame.set("sizeDisplayLabel", t_3, true);
if(frame.topLevel) {
context.setVariable("sizeDisplayLabel", t_3);
}
if(frame.topLevel) {
context.addExport("sizeDisplayLabel", t_3);
}
output += "\n\n<p class=\"c-product-tile__size\">\n    <span class=\"c-product-tile__size-label\" data-qa-size-label>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizeDisplayLabel"), env.opts.autoescape);
output += ": </span>\n\n    ";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"secondarySlice")),"sliceItems");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("sliceItem", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
if(runtime.memberLookup((t_7),"code") == runtime.contextOrFrameLookup(context, frame, "productSizeTypeCode")) {
output += "\n            ";
frame = frame.push();
var t_10 = runtime.memberLookup((t_7),"includedSizes");
if(t_10) {var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("size", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\n                ";
if(runtime.memberLookup((t_11),"id") == runtime.contextOrFrameLookup(context, frame, "productSizeId")) {
output += "\n                    <span class=\"c-product-tile__size-value\" data-qa-size-value>";
output += runtime.suppressValue(runtime.memberLookup((t_11),"displayName"), env.opts.autoescape);
output += "</span>\n                ";
;
}
;
}
}
frame = frame.pop();
output += "\n        ";
;
}
;
}
}
frame = frame.pop();
output += "\n</p>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-size.j2"] , dependencies)